









































import { Vue, Component } from 'vue-property-decorator';
import { getNewsList } from '../api';

@Component
export default class NewsList extends Vue {
  newsList: any[] = [];
  loading = false;
  finished = false;
  page = 1;
  error = false;

  created() {
    this.getNewsList();
  }
  async getNewsList() {
    this.loading = true;
    try {
      const ret: any = await getNewsList(this.page);
      this.loading = false;
      if (!ret.data.length) {
        this.finished = true;
      } else {
        this.newsList = [...this.newsList, ...ret.data];
        this.page++;
      }
    } catch (err) {
      console.log('异常报告', err);
      this.error = true;
    }
  }
  resetNewsList() {
    this.finished = false;
    this.newsList = [];
    this.page = 1;
  }
  onJumpToDetail(newsItem: any) {
    if (window.udid && newsItem.dataType !== 7 && newsItem.dataType !== 5) {
      const { id, classId, dataType } = newsItem;
      const option = {
        dt: dataType,
        cid: classId,
        nid: id,
      };
      window.handleMessage(
        JSON.stringify({
          action: 'mJump',
          data: JSON.stringify(option),
        }),
      );
    } else {
      location.href = newsItem.targetUrl;
    }
  }
}
